import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory, StringPropertyEditor } from "adaptivecards-designer";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
import { ICustomProperty } from "../../../shared/interfaces/customproperties.interface";
import { CustomPropertyBase } from "./CustomPropertyBase";
export class DateProperty extends CustomPropertyBase {
    static JsonTypeName;
    static ElementId;
    static defaultLabel;
    static customPropertyData: ICustomProperty;

    constructor(paramType, paramCustomPropertyData: ICustomProperty) {
        
        DateProperty.JsonTypeName = paramType ?? DateProperty.JsonTypeName;
        DateProperty.ElementId = paramCustomPropertyData?.PropertyId ?? DateProperty.ElementId;
        DateProperty.defaultLabel = paramCustomPropertyData?.Name ?? DateProperty.defaultLabel;
        DateProperty.customPropertyData = paramCustomPropertyData ?? DateProperty.customPropertyData;
        
        super();
    }

    internalRender(): HTMLElement | undefined {
        if((this?.id ?? "").length == 0)
            this.id = DateProperty.ElementId;

        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = DateProperty.defaultLabel;

        if((this?.dataType ?? "").length == 0)
            this.dataType = DateProperty.customPropertyData?.DataType ?? "";

        this.requireField ??= DateProperty.customPropertyData?.IsRequired ?? false;

        this.errorMessage ??= DateProperty.customPropertyData?.ErrorMessage ?? "";

        return super.internalRender();
    }

    getJsonTypeName(): string {
        return DateProperty.JsonTypeName;
    }
}

export class DatePropertyPeer extends TypedCardElementPeer<DateProperty> {
    static readonly displayLabelProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "displayLabel", "Label", false);
    static requireFieldProperty = getPropertyEditorInstance(DateProperty.ElementId, PropertyKeys.requireField);
    static readonly requiredMessageProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "errorMessage", "Error Message", false);

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);

        propertySheet.add(
            defaultCategory,
            DatePropertyPeer.idProperty,
            DatePropertyPeer.displayLabelProperty
        );

        propertySheet.add(
            "Validation",            
            DatePropertyPeer.requireFieldProperty,
            DatePropertyPeer.requiredMessageProperty
        );
    }
}